import React, { useEffect, useRef, useState } from "react";

const LazyImage = ({
    src,
    alt,
    className,
    width,
    height,
    eager = false,
    fetchpriority,
}) => {
    const imgRef = useRef(null);
    const [isVisible, setIsVisible] = useState(eager);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (eager) return; // let browser load immediately
        const node = imgRef.current;
        if (!node) return;

        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            setIsVisible(true);
                            observer.disconnect();
                        }
                    });
                },
                { rootMargin: "200px" }
            );
            observer.observe(node);
            return () => observer.disconnect();
        } else {
            // Fallback: load immediately
            setIsVisible(true);
        }
    }, [eager]);

    return (
        <img
            ref={imgRef}
            src={isVisible ? src : undefined}
            alt={alt}
            className={`${className || ""} ${isLoaded ? "" : "blur-[6px]"}`}
            loading={eager ? "eager" : "lazy"}
            decoding="async"
            fetchpriority={fetchpriority}
            width={width}
            height={height}
            onLoad={() => setIsLoaded(true)}
            style={{ transition: "filter 200ms ease" }}
        />
    );
};

export default LazyImage;
